import { MouseEvent } from 'react'
import { useAuth } from '@dustin-web/microsite-components/src/auth'
import {
  useSiteContext,
  useTranslations,
  useUserSettings,
} from '@dustin-web/microsite-components/src/hooks'
import Icon from '@dustin-web/microsite-components/src/icon'
import { DigitalData } from '@dustin-web/microsite-components/src/utils/digital-data'

export function WriteAccessStatus({ reviewWriteAccess }: { reviewWriteAccess: string }) {
  const { site, isProxied } = useSiteContext()
  const { translate } = useTranslations()
  const { twoLetterISOLanguageName } = useUserSettings()
  const { signIn } = useAuth()

  const getShortenedSiteName = (site: string) => {
    const countries = /Sweden|Norway|Denmark|Finland|Netherlands/g
    const shortSiteName = site.replace(countries, '')

    return shortSiteName
  }

  const loginHandler = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    DigitalData.accountLogin('review')

    if (!isProxied) {
      signIn({
        provider: 'okta',
        bounceUrl: window.location.origin + '/bounce/login',
        language: twoLetterISOLanguageName,
      })
      return false
    }
    window.location.href = '/login?returnUrl=' + window.location.href
  }

  if (reviewWriteAccess === 'ALLOWED') {
    return reviewWriteAccess
  } else if (reviewWriteAccess === 'NOT_AUTHENTICATED_USER') {
    return (
      <section className="product-write-review">
        <div className="product-write-review-access__auth-container">
          <div className="product-write-review-access__auth-container--icon-text">
            <Icon name="info" className="product-write-review-access__auth-container--icon" />
            <p className="product-write-review-access__auth-container--text">
              {translate('Product_Review_Denied_Log_In')}
            </p>
          </div>
          <div>
            <a
              onClick={loginHandler}
              className="product-write-review-access__auth-container--login-link"
              href="/login"
              target="_blank"
              rel="noopener noreferrer">
              {translate('Header_Login')}
            </a>
          </div>
        </div>
      </section>
    )
  } else {
    return (
      <section className="product-write-review">
        <div className="product-write-review-access__blocked-container">
          <p className="product-write-review-access__blocked-container--text">
            {reviewWriteAccess === 'ALREADY_REVIEWED_PRODUCT'
              ? translate('Product_Review_Denied_Already_Reviewed')
              : reviewWriteAccess === 'NOT_PURCHASED_PRODUCT'
              ? translate('Product_Review_Denied_Payment')
              : reviewWriteAccess === 'REVIEW_REQUEST_PENDING'
              ? translate('Product_Review_Denied_Wait_Period')
              : translate('Product_Review_Denied_Blocked', { site: getShortenedSiteName(site) })}
          </p>
        </div>
      </section>
    )
  }
}
